import React, { FC } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store/store';
import { showNotification } from 'store/reducers/ui.reducer';
import { HYPHEN } from 'modules/core/constants';

import { Stock as StockUI } from './style';

export interface IStock {
  stock: string;
}

export const Stock: FC<IStock> = ({ stock }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation();

  const isCopyable = !!stock && stock !== HYPHEN;

  if (!isCopyable) {
    return <StockUI>{stock}</StockUI>;
  }

  return (
    <CopyToClipboard
      text={stock}
      onCopy={() => dispatch(showNotification({ message: t('successfullyCopied'), type: 'successful' }))}
    >
      <StockUI isCopyable title={t('components.table.stockHelpMessage')}>
        {stock}
      </StockUI>
    </CopyToClipboard>
  );
};
